import React, {useEffect, useState} from 'react';
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import Icon from '../../../../stories/core-components/IconsSelector';
import getDateObj from '../../Common/utils/GetDateObj';
import format_BusQueryDate from '../../../utils/QueryDateFormat';
import MWebCalendar from '../../CommonResp/CalendarMWEB/MWebCalendar/MWebCalendar';
import { isMobileView } from '../../Common/utils';
import dateFormat from 'dateformat';
import MWebCalendarWrapper from './MwebCalendarWrapper'
const MobileHeader = (props) => {
    const { title = "", date = "", moveToFunnel, src, dest, src_id, dest_id, page='', operatorName='', operatorId=''} = props;
    const moveToFunnelParams = {src, dest, src_id, dest_id}
    const [showCalendar, setShowCalendar] = useState(true)
    const dateObj = (() => {
        if (date) {
            return getDateObj(format_BusQueryDate(date));
        } else {
            return getDateObj();
        };
    })();
    const calendarViewDate = dateFormat(dateObj, 'mmm dd, yyyy')
    const changeCalendar = (day = '') => {
        setShowCalendar(!showCalendar)
    }
    return (
        <>
            <div className="mobileOnly mobileHeaderWrapper" data-ol-has-click-handler="">
                <div className="makeFlex alignItemCenter">
                    <img style={{
                        width: '18px',
                        height: '18px',
                        marginRight: '15px'
                    }} data-src="https://gos3.ibcdn.com/back-1631161913.png" className="lazyload" alt="backArrow" onClick={() => {
                        moveToFunnel({ page: 'home', prefillData: true })
                    }}></img>

                    <div className="flexOne" onClick={() => {
                       if(page ==='route_page'){changeCalendar()}
                       else {moveToFunnel({ page: 'home', prefillData: true })}
                    }}>
                        {title ? <p className="headerRouteTxt" style={{
                            fontWeight: 700, maxWidth: '20rem',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        }}>{title}</p> : <></>}
                        <div className="makeFlex alignItemCenter">
                            <p className="headerDateTxt">{calendarViewDate}</p>
                            <span className="headerDropDown">
                                <Icon name="ArrowRight" styleProps={{ fill: "#fff", height: "1rem", width: "1rem" }}/>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            {showCalendar && page ==='route_page' &&
               // <MWebCalendar page={'srp'} isBusCard={''} showCalendar={showCalendar} moveToFunnelParams={moveToFunnelParams} changeCalendar={changeCalendar}/>
               <MWebCalendarWrapper operatorName={operatorName} operatorId={operatorId} page={'srp'} showCalendar={showCalendar} changeCalendar={changeCalendar} src={src} dest={dest} src_id={src_id} dest_id={dest_id} dateObj={dateObj} date={date}/>
            }
        </>
    )
}

export default MobileHeader;
